var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6006 8.0636V17.1113C12.6006 17.6021 12.2058 17.9998 11.7185 17.9998H1.88209C1.39485 17.9998 1 17.6021 1 17.1113V7.31811C1 6.82737 1.39485 6.42969 1.88209 6.42969H10.9826",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.29 8.47326C16.339 8.47326 18 6.80031 18 4.73663C18 2.67295 16.339 1 14.29 1C12.2411 1 10.5801 2.67295 10.5801 4.73663C10.5801 6.80031 12.2411 8.47326 14.29 8.47326Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61208 10.0071L7.00352 9.16538C6.9287 9.1261 6.83982 9.1261 6.765 9.16538L5.15644 10.0071C4.98431 10.0973 4.77881 9.97136 4.77881 9.77606V6.42969H8.99007V9.77606C8.99007 9.97136 8.78456 10.0973 8.61243 10.0071H8.61208Z",
    stroke: "#6856DB",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.125 14.0923H8.6256",
    stroke: "#6856DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8472 4.7365L13.6017 5.49649L15.4548 3.63013",
    stroke: "#6856DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/Stock.491ddb8ca814a78be5d81689a7c481a1.svg";
export { ForwardRef as ReactComponent };